import axios from 'axios'
import cfg from '../config/index'
import qs from 'qs'
import { Notify } from 'vant'
const baseURL = cfg.baseApi
// const auth = '' // 暂时 todo
const auth = 'orLC25MNGu-XIdLmjDncL7Y1KR_s' // 暂时 todo

const getUrlParams = () => {
  let rs = {}
  const urlStr = window.location.search || window.location.hash
  const paramStr = urlStr.split('?')[1] || ''

  if (paramStr) {
    try {
      rs = qs.parse(paramStr)
    } catch (e) {

    }
  }
  return rs
}

const getToken = () => {
  let token = ''
  const urlParam = getUrlParams()
  if (urlParam.dev) {
    token = urlParam.token || auth
    console.log(urlParam)
  } else {
    token = localStorage.getItem('token_key')
  }
  return token
}

const Message = msg => {
  console.log(msg)
}

const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    console.log(config)
    if (config.headerType === 'form') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    } else if (config.headerType === 'formData') {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }

    // // todo  需要改进方法
    // if (String(config.url).indexOf('/user/login') > -1) {
    //   config.headers.Authorization = auth
    // } else {
    //   token && (config.headers.Authorization = `bearer ${token}`)
    // }

    // config.headers.sourceType = 0 todo  0,公共号 1小程序
    if (!config.headers.sourceType)
      config.headers.sourceType = 0;

    // 赋值授权
    const token = getToken()
    config.headers.token = token

    if (config.noToken) {
      config.headers.token = ''
    }

    // get传参 键值对解析
    if (config.data && config.method.toLocaleLowerCase() === 'get') {
      config.url += `?${qs.stringify(config.data)}`
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const headers = response.headers
    const res = response
    const config = response.config

    const ct = headers['content-type']
    if (ct.indexOf('application/x-www-form-urlencoded;charset=UTF-8') < 0 && ct.indexOf('application/json;charset=UTF-8') < 0) {
      return res
    }
    // console.log(res)
    // 如果状态码不为 0 并且存在message 字段
    const _res = res.data
    if (_res.status !== 0) {
      if (!config.notPopMessage) {
        Notify({ type: 'danger', message: _res.details })
      }
      // return Promise.reject(new Error(res.message || 'Error'))
      return res
    } else {
      return res
    }
  },
  error => {
    if (error && error.message) {
      // let RegExE = /timeout of [0-9]+ms exceeded/;
      let message = error.message
      error.message.includes('timeout') && (message = '请求超时')
      Message({
        message: `${message}`,
        type: 'error'
      })
      Promise.reject(error)
    }
  }
)

export default service
